import { Card, CardContent, Typography } from "@mui/material";
import { FC } from "react";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import {
  CreditosOrganizacion,
  CreditosSuborganizacion,
  CreditosSuscripcion,
  CreditosUsario,
} from "../../../interfaces/SuperAdmin/Pages/iDataCreditos";
import { PieChartTooltip } from "./PieChartTooltip";

interface Props {
  data: any[];
  title: string;
  label: string;
  value: string;
  hasCredits: boolean;
}

const generateColor = (index: number) => {
  const hue = (index * 50) % 360; // cada 50° en el círculo de color
  return `hsl(${hue}, 90%, 60%)`;
};

const CustomPieChart: FC<Props> = ({
  data,
  title,
  label,
  value,
  hasCredits,
}) => {
  return (
    <Card sx={{ height: 1 }}>
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          height: 1,
          color: "#336B87",
        }}
      >
        <Typography variant="h6" fontWeight="bold" sx={{ marginBottom: 2 }}>
          {title}
        </Typography>
        {data.length && hasCredits ? (
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                innerRadius={30}
                outerRadius={50}
                fill="#8884d8"
                dataKey={value}
                nameKey={label}
              >
                {data?.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={generateColor(index)} />
                ))}
              </Pie>
              <Tooltip content={<PieChartTooltip />} />
            </PieChart>
          </ResponsiveContainer>
        ) : !data.length ? (
          <Typography
            component="div"
            sx={{
              textAlign: "center",
              fontStyle: "italic",
              opacity: 0.7,
              flexGrow: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            No hay info
          </Typography>
        ) : (
          <Typography
            component="div"
            variant="h4"
            fontWeight="bold"
            sx={{
              textAlign: "center",
              flexGrow: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            0
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default CustomPieChart;
